import { render } from "./DataView.vue?vue&type=template&id=5721238a&scoped=true"
import script from "./DataView.vue?vue&type=script&lang=js"
export * from "./DataView.vue?vue&type=script&lang=js"

import "./DataView.vue?vue&type=style&index=0&id=5721238a&scoped=true&lang=less"

import exportComponent from "/Users/woniu/Desktop/woniu/web-tuiguangzu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5721238a"]])

export default __exports__